import { RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { ReactNode, useState } from 'react';

import ExpandableContent from 'components/Generic/ExpandableContent';

type AccordionDefaultProps = {
  title: object;
  description: object;
  children?: ReactNode;
  className?: string;
};

const AccordionDefault = ({ title, description, children, className }: AccordionDefaultProps) => {
  const [show, setShow] = useState(false);
  return (
    <div
      className={`accordion-default flex-column d-flex align-items-start accordion-item mb-1 ${className}`}
    >
      <button
        className="btn btn-naked text-link d-flex align-items-center justify-content-between w-100"
        aria-expanded={show ? 'true' : 'false'}
        onClick={() => setShow(!show)}
      >
        <Text tag="h3" field={title} className="form-label accordion-title mb-0" />
        <span className="ms-auto">
          <em className="d-flex bi-chevron-down" aria-hidden="true" />
        </span>
      </button>
      <ExpandableContent show={show}>
        <div className="background-white pb-2 px-2">
          <RichText
            field={description}
            className="body-small d-flex flex-column accordion-description"
          />
          {children}
        </div>
      </ExpandableContent>
    </div>
  );
};

export default AccordionDefault;
